import cn from 'classnames';
import { VStack } from '@direct-frontend/components';
import zoomDownIconSource from './assets/zoomDown.svg';
import zoomUpIconSource from './assets/zoomUp.svg';
import styles from './ZoomControls.module.css';

interface ZoomControlsProps {
    onZoomUpClick: () => void;
    onZoomDownClick: () => void;
    className?: string;
}

export const ZoomControls = (props: ZoomControlsProps) => {
    const { onZoomUpClick, onZoomDownClick, className } = props;

    return (
        <VStack className={cn(className, styles.container)}>
            <button className={cn(styles.zoomButton, styles.zoomUpButton)} onClick={onZoomUpClick}>
                <img width="24" src={zoomUpIconSource} alt="Увеличить" draggable={false} />
            </button>
            <button className={cn(styles.zoomButton, styles.zoomDownButton)} onClick={onZoomDownClick}>
                <img width="24" src={zoomDownIconSource} alt="Уменьшить" draggable={false} />
            </button>
        </VStack>
    );
};
